import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const Value = styled.span`
  text-align: right;
  font-weight: bold;
`;

const DataRow = (props: {
  label: string;
  value?: string | number;
  valueClassName?: string;
}): JSX.Element => {
  return (
    <Wrapper className="text-14">
      <span>{props.label}</span>
      <Value className={props.valueClassName}>{props.value || 'n.a.'}</Value>
    </Wrapper>
  );
};

export default DataRow;
